export const visit = (vm, at) => {
at({ "hu": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "\xDAj \xFCzenet" } } });
};